const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        this.slickSlider();
		this.logosSlider();
    },

	slickSlider: function() {
		let $slider = $(".slider-date__box-wrapper");
	
		$slider.slick({
			dots: true,
			arrows: true,
			prevArrow: '.prev',
			nextArrow: '.next',
			customPaging: function(slider, i) { 
				return '<button class="tab">' + $(slider.$slides[i]).attr('title') + '</button>';
			},
			infinite: false,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						adaptiveHeight: true
					}
				}
			]
		});
	
		function updateDots() {
			let $dots = $slider.find('.slick-dots li');
			let totalSlides = $slider.slick('getSlick').$slides.length;
	
			if (totalSlides > 3) {
				$dots.hide().slice(0, 3).show(); // Prikazujemo samo prva 3
			} else {
				$dots.show(); // Ako ima 1 ili 2 slajda, prikaži sve
			}
		}
	
		// Kada je slider inicijalizovan
		$slider.on('init', function() {
			setTimeout(updateDots, 10); // Dodajemo mali delay da osiguramo ispravno skrivanje
		});
	
		// Kada se promeni slajd
		$slider.on('afterChange', function(event, slick, currentSlide) {
			let $dots = $slider.find('.slick-dots li');
			let totalSlides = slick.$slides.length;
	
			if (totalSlides > 3) {
				let start = Math.min(currentSlide, totalSlides - 3); // Osiguravamo da uvek budu vidljiva 3 elementa
				$dots.hide().slice(start, start + 3).show();
			} else {
				$dots.show(); // Ako ima 1 ili 2 slajda, prikaži sve
			}
		});
	
		// Osiguravamo da se dots ažuriraju i kada je sve učitano
		$(document).ready(function() {
			setTimeout(updateDots, 100);
		});
	},	

	logosSlider: function() {
		$(".slider-images-items").slick({
			autoplay: true,
			autoplaySpeed: 750,
			dots: false,
			arrows: false,
			slidesToScroll: 1,
			slidesToShow: 5,
			rows: 0,
			responsive: [
				{
					breakpoint: 1366,
					settings: {
						slidesToShow: 4,
						infinite: true,
					}
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						centerMode: true,
						centerPadding: '60px',
						autoplay: true
					}
				}
			]
		});
	}
}

export default _this;